import React from 'react';
import { useDispatch } from 'react-redux';
import Button from '../../components/Button';
import Modal from '../../components/Modal';
import { Action } from '../../components/Reposit/RepositSummary/styles';
import { Header3, P2 } from '../../components/Typography';
import { grantOrganizationUserRolesRequested } from '../../redux/organization-user/organization-user.actions';

interface GrantRolesModalProps {
  onDismiss: () => void;
  userId: string;
  organizationId: string;
}

export const GrantRolesModal: React.FC<GrantRolesModalProps> = ({ onDismiss, userId, organizationId }) => {
  const dispatch = useDispatch();
  const onSubmit = () => {
    dispatch(grantOrganizationUserRolesRequested({ userId, organizationId }));
    onDismiss();
  };
  return (
    <Modal onDismiss={onDismiss}>
      <Header3 style={{ marginBottom: 6 }}>Grant Admin Roles</Header3>
      <P2>
        Are you sure you want to grant admin roles to this user? They will be able to handle onboarding, and manage users, bank
        accounts and recipients.
      </P2>
      <Action style={{ marginTop: 16, justifyContent: 'flex-end', display: 'flex', flexDirection: 'row', columnGap: '10px' }}>
        <Button buttonType="secondary" noArrow={true} onClick={onDismiss}>
          Cancel
        </Button>
        <Button onClick={onSubmit}>Confirm</Button>
      </Action>
    </Modal>
  );
};
